import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { permanentRedirect } from '../helpers';

/** Redirects the old `/workflow` (singular) routes to the `/workflows` (plural) routes. */
export default function WorkflowRedirect() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const redirect = permanentRedirect(navigate);

  useEffect(() => {
    if (pathname === '/workflow') {
      redirect('/workflows');
      return;
    }

    if (pathname.endsWith('/create')) {
      redirect('/workflows/create');
      return;
    }

    if (pathname.endsWith('/select')) {
      redirect('/workflows/select');
      return;
    }

    if (pathname.endsWith('/jobs')) {
      redirect('/workflows/jobs');
      return;
    }

    if (pathname.endsWith('/jobs/details')) {
      const jobId = searchParams.get('jobid') || searchParams.get('jobId');

      redirect(`/workflows/jobs/${jobId}`);
      return;
    }

    if (pathname.endsWith('/edit')) {
      const workflowId = searchParams.get('workflowid') || searchParams.get('workflowId');

      redirect(`/workflows/${workflowId}`);
      return;
    }
  }, [pathname, searchParams]);

  return null;
}
